import React, { useEffect, useState } from "react";
import { clientsAPI } from "../../Api";
import {
  Container, Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Paper, IconButton, Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField, Alert,
  FormControl, InputLabel, Select, MenuItem,
  Pagination, Stack
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import PanoramaIcon from '@mui/icons-material/Panorama';

const ListClients = () => {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editClient, setEditClient] = useState(null);
  const [editData, setEditData] = useState({ lastName: "", firstName: "",market:"", cookies: "", proxy_ip: "", proxy_port: "", proxy_username: "", proxy_password: "", busy: "" });
  const [deleteId, setDeleteId] = useState(null);
  const [alert, setAlert] = useState(null);
  const [pagination, setPagination] = useState({
    totalItems: 0,
    totalPages: 0,
    currentPage: 1,
    itemsPerPage: 50
  });
  const [statistics, setStatistics] = useState({
    totalClients: 0,
    busyClients: 0,
    freeClients: 0
  });
  
  // Состояние для фильтров
  const [filters, setFilters] = useState({
    market: "",
    status: "",
    search: ""
  });
  
  // Таймаут для отложенного поиска при вводе текста
  const [searchTimeout, setSearchTimeout] = useState(null);

  // Функция для загрузки клиентов с прямой передачей фильтров
  const fetchClientsWithFilters = async (page = 1, customFilters) => {
    setLoading(true);
    try {
      console.log('Запрос клиентов с прямыми фильтрами:', JSON.stringify(customFilters));
      console.log('Переданные фильтры - маркет:', customFilters.market, 'статус:', customFilters.status, 'поиск:', customFilters.search);
      
      const res = await clientsAPI.getClients(page, pagination.itemsPerPage, customFilters);
      // Ожидаем, что res.data = { success: true, data: [...], pagination: {...} }
      console.log('Ответ от сервера:', res.data);
      console.log('Применённые прямые фильтры при запросе:', customFilters);
      
      if (res.data && res.data.success && Array.isArray(res.data.data)) {
        setClients(res.data.data);
        
        // Обработка данных пагинации
        if (res.data.pagination) {
          setPagination({
            totalItems: res.data.pagination.totalItems || 0,
            totalPages: res.data.pagination.totalPages || 0,
            currentPage: res.data.pagination.currentPage || 1,
            itemsPerPage: res.data.pagination.itemsPerPage || 50
          });
        }
        
        // Обработка данных статистики
        if (res.data.statistics) {
          console.log('Статистика из ответа:', res.data.statistics);
          setStatistics({
            totalClients: res.data.statistics.totalClients || 0,
            busyClients: res.data.statistics.busyClients || 0,
            freeClients: res.data.statistics.freeClients || 0
          });
        } else {
          console.log('Статистика отсутствует в ответе');
          // Если статистика отсутствует, но есть данные клиентов
          // Можно вычислить статистику на основе полученных данных
          if (Array.isArray(res.data.data) && res.data.data.length > 0) {
            const totalClients = res.data.data.length;
            const busyClients = res.data.data.filter(client => client.status === 'busy').length;
            const freeClients = totalClients - busyClients;
            
            console.log('Вычисленная статистика:', { totalClients, busyClients, freeClients });
            
            setStatistics({
              totalClients,
              busyClients,
              freeClients
            });
          }
        }
      } else {
        setClients([]);
        setAlert(<Alert severity="error">Некорректный ответ сервера</Alert>);
      }
    } catch (e) {
      setClients([]);
      setAlert(<Alert severity="error">Ошибка загрузки клиентов</Alert>);
    } finally {
      setLoading(false);
    }
  };
  
  // Оригинальная функция для загрузки клиентов с использованием текущего состояния фильтров
  const fetchClients = async (page = 1) => {
    // Просто вызываем новую функцию с текущими фильтрами
    await fetchClientsWithFilters(page, filters);
  };

  useEffect(() => { fetchClients(pagination.currentPage); }, []);
  
  // Обработчик изменения фильтров
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    console.log('Изменение фильтра:', name, 'значение:', value);
    
    // Создаем новый объект фильтров
    const newFilters = {
      ...filters,
      [name]: value
    };
    
    console.log('Новые фильтры:', newFilters);
    
    // Обновляем состояние фильтров
    setFilters(newFilters);
    
    // Сбрасываем страницу на первую при изменении фильтров
    if (pagination.currentPage !== 1) {
      setPagination(prev => ({
        ...prev,
        currentPage: 1
      }));
    }
    
    // Всегда используем новые фильтры напрямую
    // вместо состояния filters, которое обновляется асинхронно
    const fetchWithNewFilters = () => {
      // Вызываем модифицированную версию fetchClients с прямой передачей фильтров
      fetchClientsWithFilters(1, newFilters);
    };
    
    // Используем setTimeout для уверенности, что состояние обновится
    setTimeout(fetchWithNewFilters, 0);
  };
  
  // Обработчик поиска с задержкой
  const handleSearchChange = (e) => {
    const { value } = e.target;
    console.log('Изменение поиска:', value);
    
    // Очищаем предыдущий таймаут, если он есть
    if (searchTimeout) {
      clearTimeout(searchTimeout);
    }
    
    // Создаем новый объект фильтров
    const newFilters = {
      ...filters,
      search: value
    };
    
    // Обновляем значение поиска в состоянии
    setFilters(newFilters);
    
    // Устанавливаем новый таймаут для отложенного поиска
    const timeout = setTimeout(() => {
      console.log('Запуск поиска с фильтрами:', newFilters);
      // Используем прямую передачу фильтров
      fetchClientsWithFilters(1, newFilters);
    }, 500); // Задержка 500мс
    
    setSearchTimeout(timeout);
  };
  
  // Обработчик сброса фильтров
  const handleResetFilters = () => {
    console.log('Сброс фильтров');
    
    // Создаем пустой объект фильтров
    const emptyFilters = {
      market: "",
      status: "",
      search: ""
    };
    
    // Обновляем состояние
    setFilters(emptyFilters);
    
    // Используем прямую передачу пустых фильтров
    fetchClientsWithFilters(1, emptyFilters);
  };

  const handlePageChange = (event, newPage) => {
    fetchClients(newPage);
  };


  const handleEditOpen = (client) => {
    setEditClient(client);
    setEditData({
      lastName: client.lastName,
      firstName: client.firstName,
      market:client.market,
      cookies: typeof client.cookies === "object" ? JSON.stringify(client.cookies) : client.cookies || "",
      proxy_ip: client.proxy_ip || "",
      proxy_port: client.proxy_port || "",
      proxy_username: client.proxy_username || "",
      proxy_password: client.proxy_password || "",
      busy: client.busy || ""
    });
  };

  const handleEditChange = (e) => {
    setEditData({ ...editData, [e.target.name]: e.target.value });
  };

  const handleEditSave = async () => {
    try {
      let cookiesObj;
      try { cookiesObj = JSON.parse(editData.cookies); } catch { cookiesObj = editData.cookies; }
      const result = await clientsAPI.updateClient(editClient._id, {
        lastName: editData.lastName,
        firstName: editData.firstName,
        market: editData.market,
        cookies: cookiesObj,
        proxy_ip: editData.proxy_ip,
        proxy_port: editData.proxy_port,
        proxy_username: editData.proxy_username,
        proxy_password: editData.proxy_password,
        busy: editData.busy
      });
      setAlert(<Alert severity="success">Клиент обновлён</Alert>);
      setEditClient(null);
      fetchClients(pagination.currentPage);
    } catch {
      setAlert(<Alert severity="error">Ошибка обновления клиента</Alert>);
    }
  };

  const handleDelete = async () => {
    try {
      await clientsAPI.deleteClient(deleteId);
      setAlert(<Alert severity="success">Клиент удалён</Alert>);
      setDeleteId(null);
      fetchClients(pagination.currentPage);
    } catch {
      setAlert(<Alert severity="error">Ошибка удаления клиента</Alert>);
    }
  };
  const checkScreens = async (client) => {
    try {
      const scrdata = await clientsAPI.getScreen(client._id)
      console.log('test', scrdata.data)
    } catch(err) {
      console.log('err', err)
    }
  }
  return (
    <Container maxWidth="sd">
      <Box sx={{ mt: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Список клиентов
        </Typography>
        <Button variant="contained" href="/clients/add" sx={{ mb: 2 }}>
          Добавить клиента
        </Button>
        
        {/* Панель фильтрации */}
        <Paper sx={{ p: 2, mb: 2 }}>
          <Typography variant="h6" component="h2" gutterBottom>
            Фильтры
          </Typography>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, alignItems: 'center' }}>
            {/* Фильтр по маркету */}
            <FormControl sx={{ minWidth: 200 }}>
              <InputLabel>Маркет</InputLabel>
              <Select
                name="market"
                value={filters.market}
                onChange={handleFilterChange}
                label="Маркет"
                size="small"
              >
                <MenuItem value=""><em>Все</em></MenuItem>
                <MenuItem value="yandex">Яндекс Маркет</MenuItem>
                <MenuItem value="funpay">FunPay</MenuItem>
              </Select>
            </FormControl>
            
            {/* Фильтр по статусу */}
            <FormControl sx={{ minWidth: 200 }}>
              <InputLabel>Статус</InputLabel>
              <Select
                name="status"
                value={filters.status}
                onChange={handleFilterChange}
                label="Статус"
                size="small"
              >
                <MenuItem value=""><em>Все</em></MenuItem>
                <MenuItem value="false">Свободен</MenuItem>
                <MenuItem value="true">Занят</MenuItem>
              </Select>
            </FormControl>
            
            {/* Поиск */}
            <TextField
              label="Поиск"
              name="search"
              value={filters.search}
              onChange={handleSearchChange}
              placeholder="Введите имя или фамилию"
              size="small"
              sx={{ minWidth: 250 }}
            />
            
            {/* Кнопка сброса фильтров */}
            <Button 
              variant="outlined" 
              onClick={handleResetFilters}
              size="small"
            >
              Сбросить фильтры
            </Button>
          </Box>
        </Paper>
        
        {/* Блок статистики */}
        <Box sx={{ 
            display: 'flex', 
            flexDirection: 'column', 
            backgroundColor: '#f5f0f5', 
            padding: 2, 
            marginBottom: 3, 
            borderRadius: 1,
            boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)'
        }}>
          <Typography variant="h6" sx={{ color: '#683d62', marginBottom: 1, fontWeight: 'bold' }}>
              Статистика аккаунтов
          </Typography>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
              <Box>
                  <Typography variant="subtitle2" sx={{ color: '#683d62' }}>
                     Всего аккаунтов:
                  </Typography>
                  <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                      {statistics.totalClients}
                  </Typography>
              </Box>
              <Box>
                  <Typography variant="subtitle2" sx={{ color: '#683d62' }}>
                      Занятых аккаунтов:
                  </Typography>
                  <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                      {statistics.busyClients}
                  </Typography>
              </Box>
              <Box>
                  <Typography variant="subtitle2" sx={{ color: '#683d62' }}>
                      Свободных аккаунтов:
                  </Typography>
                  <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                      {statistics.freeClients}
                  </Typography>
              </Box>
          </Box>
        </Box>
   
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Статус</TableCell>
                <TableCell>Ордер</TableCell>
                <TableCell>Фамилия</TableCell>
                <TableCell>Имя</TableCell>
                <TableCell>Маркет</TableCell>
                <TableCell>Cookies</TableCell>
                <TableCell>Прокси IP</TableCell>
                <TableCell>Прокси Порт</TableCell>
                <TableCell>Прокси Юзер</TableCell>
                <TableCell>Прокси Пароль</TableCell>
                <TableCell align="right">Действия</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <TableRow><TableCell colSpan={4}>Загрузка...</TableCell></TableRow>
              ) : !Array.isArray(clients) || clients.length === 0 ? (
                <TableRow><TableCell colSpan={4}>Нет клиентов</TableCell></TableRow>
              ) : clients.map(client => (
                <TableRow key={client._id}>
                  <TableCell
                    sx={{ backgroundColor: client.busy ? "red" : "green" }}
                  >{client.busy ? "Занят" : "Свободен"}</TableCell>
      <TableCell sx={{ backgroundColor: client.order ? "white" : "green" }}>
  {!client.order?._id ? "Не использован" : "Использован"}
</TableCell>

                  <TableCell >{client.lastName}</TableCell>
                  <TableCell>{client.firstName}</TableCell>
                  <TableCell>{client.market}</TableCell>
                  <TableCell sx={{ maxWidth: 200, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                    {typeof client.cookies === "object" ? JSON.stringify(client.cookies) : client.cookies}
                  </TableCell>
                  <TableCell>{client.proxy_ip}</TableCell>
                  <TableCell>{client.proxy_port}</TableCell>
                  <TableCell>{client.proxy_username}</TableCell>
                  <TableCell>{client.proxy_password}</TableCell>
                  <TableCell align="right">
                
                  <IconButton
                    color="success"
                    onClick={() => window.open(`${process.env.REACT_APP_API_URL}/screanclient/${client._id}`, '_blank')}
                  >
                  <PanoramaIcon />
                </IconButton>
                    <IconButton color="primary" onClick={() => handleEditOpen(client)}><EditIcon /></IconButton>
                    <IconButton color="error" onClick={() => setDeleteId(client._id)}><DeleteIcon /></IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        
        {/* Пагинация */}
        {pagination.totalPages > 1 && (
          <Stack spacing={2} sx={{ mt: 2, display: 'flex', alignItems: 'center' }}>
            <Pagination 
              count={pagination.totalPages} 
              page={pagination.currentPage} 
              onChange={handlePageChange} 
              color="primary" 
              showFirstButton 
              showLastButton
              siblingCount={1}
            />
            <Typography variant="body2" color="text.secondary">
              Страница {pagination.currentPage} из {pagination.totalPages} (всего {pagination.totalItems} клиентов)
            </Typography>
          </Stack>
        )}
        {/* Диалог редактирования */}
        <Dialog open={!!editClient} onClose={() => setEditClient(null)}>
          <DialogTitle>Редактировать клиента</DialogTitle>
          <DialogContent>
            <FormControl sx={{ minWidth: 200 }}>
            <InputLabel>Занятость</InputLabel>
            <Select
              name="busy"
              value={editData.busy}
              onChange={handleEditChange}
              label="Занятость"
              size="small"
            >
              <MenuItem value=""><em>Все</em></MenuItem>
              <MenuItem value="true">Занят</MenuItem>
              <MenuItem value="false">Свободен</MenuItem>
            </Select>
            </FormControl>
            <TextField
              margin="dense"
              label="Фамилия"
              name="lastName"
              value={editData.lastName}
              onChange={handleEditChange}
              fullWidth
            />
            <TextField
              margin="dense"
              label="Имя"
              name="firstName"
              value={editData.firstName}
              onChange={handleEditChange}
              fullWidth
            />
        <FormControl
  fullWidth
  margin="normal"
  sx={{
    "& .MuiOutlinedInput-root": {
      "&.Mui-focused fieldset": { borderColor: "#683d62" },
    },
    "& .MuiInputBase-input": { "&:focus": { color: "#683d62" } },
    "& .MuiInputLabel-root": { "&.Mui-focused": { color: "#683d62" } },
  }}
>
  <InputLabel shrink>Маркет</InputLabel>
  <Select
    name="market" // ВАЖНО! Чтобы handleEditChange понимал, что обновлять
    value={editData.market}
    onChange={handleEditChange} // без стрелки — напрямую
    label="Маркет"
    displayEmpty
    notched
  >
    <MenuItem value=""><em>Выберите маркет</em></MenuItem>
    <MenuItem value="yandex">Яндекс Маркет</MenuItem>
    <MenuItem value="funpay">FunPay</MenuItem>
  </Select>
</FormControl>
            <TextField
              margin="dense"
              label="Cookies (JSON или строка)"
              name="cookies"
              value={editData.cookies}
              onChange={handleEditChange}
              fullWidth
            />
            <TextField
              margin="dense"
              label="Прокси ИП"
              name="proxy_ip"
              value={editData.proxy_ip}
              onChange={handleEditChange}
              fullWidth
            />
            <TextField
              margin="dense"
              label="Прокси Порт"
              name="proxy_port"
              value={editData.proxy_port}
              onChange={handleEditChange}
              fullWidth
            />
            <TextField
              margin="dense"
              label="Прокси Юзер"
              name="proxy_username"
              value={editData.proxy_username}
              onChange={handleEditChange}
              fullWidth
            />
            <TextField
              margin="dense"
              label="Прокси Пароль"
              name="proxy_password"
              value={editData.proxy_password}
              onChange={handleEditChange}
              fullWidth
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setEditClient(null)}>Отмена</Button>
            <Button variant="contained" onClick={handleEditSave}>Сохранить</Button>
          </DialogActions>
        </Dialog>
        {/* Диалог удаления */}
        <Dialog open={!!deleteId} onClose={() => setDeleteId(null)}>
          <DialogTitle>Удалить клиента?</DialogTitle>
          <DialogActions>
            <Button onClick={() => setDeleteId(null)}>Отмена</Button>
            <Button variant="contained" color="error" onClick={handleDelete}>Удалить</Button>
          </DialogActions>
        </Dialog>
      </Box>
    </Container>
  );
};

export default ListClients;
